<template>
  <b-row class="mt-4 pr-3">
    <b-col class="pr-0">
      <statistic-tile
        :text="'Customer'"
        :fa-icon="customerIcon"
        :variant="'dark'"
      >
        <template #stat_value>
          <i v-if="customer_loading" class="fa fa-spin fa-spinner" />
          <span v-else>
            {{ customer.short_name }}
          </span>
        </template>
      </statistic-tile>
    </b-col>
    <b-col class="pr-0">
      <statistic-tile
        :text="'Contact(s)'"
        :fa-icon="customerContactIcon"
        :variant="'dark'"
      >
        <template #stat_value>
          <i v-if="contact_loading" class="fa fa-spin fa-spinner" />
          <span v-else>
            {{ contact.fullName() }}
          </span>
        </template>
      </statistic-tile>
    </b-col>
    <b-col class="pr-0">
      <statistic-tile
        :text="'Location'"
        :fa-icon="customerLocationIcon"
        :variant="'dark'"
      >
        <template #stat_value>
          <i v-if="location_loading" class="fa fa-spin fa-spinner" />
          <span v-else>
            {{ location.shortAddress() }}
          </span>
        </template>
      </statistic-tile>
    </b-col>
  </b-row>
</template>

<script>
import StatisticTile from "@/components/shared/StatisticTile";
import CustomerModel from "@/models/crm/CustomerModel";
import CustomerLocationModel from "@/models/crm/CustomerLocationModel";
import CustomerContactModel from "@/models/crm/CustomerContactModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import { mapGetters } from "vuex";
import { getModel } from "@/shared/fetch-utils";

export default {
  components: { StatisticTile },
  name: "ProjectWizardTracker",
  props: {
    sampleType: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      customer: null,
      customer_loading: true,
      contact: null,
      contact_loading: true,
      location: null,
      location_loading: true,
    };
  },
  computed: {
    ...mapGetters({
      step_one: "projectFormStepOne",
    }),
    sampleTypeName() {
      return this.sampleType ? this.sampleType.name : null;
    },
    customerIcon() {
      return CustomerModel.iconStatic();
    },
    customerContactIcon() {
      return CustomerContactModel.iconStatic();
    },
    customerLocationIcon() {
      return CustomerLocationModel.iconStatic();
    },
    sampleTypeIcon() {
      return SampleTypeModel.iconStatic();
    },
  },
  methods: {
    async init() {
      this.step_one.customer_id &&
        (this.customer = await getModel({
          model_type: "customer",
          id: this.step_one.customer_id,
          message: this.$bvToast,
        }));
      this.customer && (this.customer_loading = false);
      this.step_one.location_id &&
        (this.location = await getModel({
          model_type: "customer_location",
          id: this.step_one.location_id,
          message: this.$bvToast,
        }));
      this.location && (this.location_loading = false);
      this.step_one.contacts.length &&
        (this.contact = await getModel({
          model_type: "customer_contact",
          id: this.step_one.contacts[0],
          message: this.$bvToast,
        }));
      this.contact && (this.contact_loading = false);
    },
  },
  created() {
    this.init();
  },
};
</script>
